import { useWorkOrderModalsContext } from "@/shared/work-orders-modals/context/work-order-modals.context";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
} from "@mui/material";
import Button from "@mui/material/Button";
import Grid2 from '@mui/material/Grid2';
import { useState } from "react";

export const PreviewerAttachment = () => {
	const [fullWidth, setFullWidth] = useState(true);

	const {
		state: { rowSelectedInAttachment, displayViewerAttachment },
		actions: { setDisplayViewerAttachment },
	} = useWorkOrderModalsContext();

	const handleCancel = () => {
		setDisplayViewerAttachment(false);
	};

	const getFileUrl = (path: string | undefined): string => {
		if (!path) return "";

		// If path already starts with http:// or https://, return as is (e.g., from URL field in upload response)
		if (path.startsWith("http://") || path.startsWith("https://")) {
			return path;
		}

		// Use relative path to uploads endpoint served by backend
		// Backend serves files at /uploads/* via static file middleware (MesfRouting.cs:57-67)
		const relativePath = path.startsWith("/") ? path.substring(1) : path;
		return `/uploads/${relativePath}`;
	};

	return (
		<>
			<Dialog
				fullWidth={fullWidth}
				open={displayViewerAttachment}
				onClose={() => handleCancel()}>
				<Grid2 container style={{ padding: "15px 0 0" }}>
					<Grid2 size={{ xs: 12, md: 12 }}>
						<DialogTitle
							id="max-width-dialog-title"
							style={{ padding: "5px 24px 10px" }}>
							{rowSelectedInAttachment?.FileName}
						</DialogTitle>
					</Grid2>
					<Grid2 container>
						<DialogContent
							dividers
							style={{ height: "50vh", paddingTop: "20px" }}>
							<Grid2 size={{ xs: 12, md: 12 }} style={{ justifyContent: "center", alignItems: "center", height: "100%", maxHeight: "100%", minHeight: "100%", paddingBottom: "5px", }}>
								<object
									data={getFileUrl(rowSelectedInAttachment?.Path)}
									type="image/PNG"
									style={{
										objectFit: "contain",
										height: "100%",
										width: "100%",
										display: "flex",
										alignItems: "center",
									}}>
									<img
										style={{
											objectPosition: "center",
											verticalAlign: "middle",
											objectFit: "contain",
											height: "50%",
											width: "100%",
										}}
										src="img/notFound.jpg"
										alt={`Drawing: ${rowSelectedInAttachment?.FileName}`}
										loading="lazy" />
								</object>
							</Grid2>
						</DialogContent>
					</Grid2>

					<Grid2 size={{ xs: 12, md: 12 }} style={{ padding: "20px 0" }}>
						<DialogActions style={{ padding: "0px 24px" }}>
							<Grid2 size={{ xs: 6, md: 3 }}>
								<Button
									fullWidth
									variant="contained"
									onClick={handleCancel}>
									CLOSE
								</Button>
							</Grid2>
						</DialogActions>
					</Grid2>
				</Grid2>
			</Dialog>
		</>
	);
};
